export const getContextMenuItems = (type) => {
  const paste = {
    label: "Paste",
    icon: "content_paste",
    color: "icon_green",
    action: "Paste"
  };

  const deleteItem = {
    label: "Delete",
    icon: "delete",
    color: "icon_red",
    action: "Delete",
    danger: true
  };

  const allItems = [
    {
      label: "Copy",
      icon: "content_copy",
      color: "icon_blue",
      action: "Copy"
    },
    {
      label: "Cut",
      icon: "content_cut",
      color: "icon_orange",
      action: "Cut"
    },
    paste,
    {
      label: "Duplicate",
      icon: "add",
      color: "icon_indigo",
      action: "Duplicate"
    },
    deleteItem
  ];

  if (type === "section") {
    return [paste, deleteItem];
  }

  if (type === "element") {
    return allItems.filter((item) => item.action !== "Paste");
  }

  return allItems;
};
